<template>
  <ItemDialog ref="dialogConfirmRefundlApplication" image-type="alert">
    <template #content-area>
      <h2>払い戻し申請</h2>
      <p class="text-jutify">
        以下のボタンから払い戻し申請を受け付けます。払い戻し処理には少々お時間を頂きます。返金までいましばらくお待ちください。​
      </p>
      <p class="text-justify red-text">
        払い戻し申請を実行するとこのチケットは利用・変更できなくなります。​<br />一度申請すると取り消しできませんのでご注意ください。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="払い戻し申請"
        action-type="btn-primary"
        @clicked="confirmRefundApplication()"
      />
      <ItemButton
        label="キャンセル"
        action-type="btn-cancel"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>
<script>
import { ref } from "vue";

export default {
  name: "DialogConfirmRefundlApplication",
  setup(_, context) {
    const dialogConfirmRefundlApplication = ref(null);

    const confirmRefundApplication = () => {
      context.emit("confirmRefundApplication");
    };

    const openDialog = () => {
      dialogConfirmRefundlApplication.value.open();
    };

    const closeDialog = () => {
      dialogConfirmRefundlApplication.value.close();
    };

    return {
      dialogConfirmRefundlApplication,
      confirmRefundApplication,
      openDialog,
      closeDialog,
    };
  },
};
</script>
<style scoped lang="scss">
.text-justify {
  text-align: justify;
}
.red-text {
  color: #da3b31 !important;
}
</style>
